import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {ref} from 'vue';

/**
 * Standardwerte eines Dialogs. Bei jedem open() wird auf diese zurückgesetzt,
 * damit nicht gesetzte Optionen NICHT die Werte des vorherigen Dialogs erben
 * (sonst bleibt z.B. fullscreen aus einem früheren Aufruf hängen).
 */
interface PopupOptions {
  contentFilled?: boolean,
  dialogTitle?: string,
  maxWidth?: number,
  fullscreen?: boolean,
  persistent?: boolean,
  model2?: any,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UniversalPopup',
  setup(__props, { expose: __expose }) {

const DEFAULTS = {
  dialogTitle: 'Dialog',
  maxWidth: undefined as number | undefined,
  contentFilled: false,
  fullscreen: false,
  persistent: false,
  model2: 0 as any,
};

const isOpen = ref(false);
const component = ref<any>(null);
const props = ref<any>({});
const title = ref<string>(DEFAULTS.dialogTitle);
const max_width = ref<number | undefined>(DEFAULTS.maxWidth);
const content_filled = ref<boolean>(DEFAULTS.contentFilled);
const fullscreen = ref<boolean>(DEFAULTS.fullscreen);
const persistent = ref<boolean>(DEFAULTS.persistent);
const model2 = ref<any>(DEFAULTS.model2);

function open(comp: any, compProps = {}, options: PopupOptions = {}) {
  component.value = comp;
  props.value = compProps;
  title.value = options.dialogTitle ?? DEFAULTS.dialogTitle;
  max_width.value = options.maxWidth ?? DEFAULTS.maxWidth;
  content_filled.value = options.contentFilled ?? DEFAULTS.contentFilled;
  fullscreen.value = options.fullscreen ?? DEFAULTS.fullscreen;
  persistent.value = options.persistent ?? DEFAULTS.persistent;
  model2.value = options.model2 ?? DEFAULTS.model2;
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
}

__expose({open, close});

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isOpen).value = $event)),
    fullscreen: fullscreen.value,
    "max-width": max_width.value,
    persistent: persistent.value
  }, {
    default: _withCtx(() => [
      (!content_filled.value)
        ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                color: "toolbar",
                dark: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(title.value), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    onClick: close
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("mdi-close")
                        ])),
                        _: 1,
                        __: [3]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), _mergeProps({
                    model2: model2.value.value,
                    "onUpdate:model2": _cache[0] || (_cache[0] = ($event: any) => ((model2.value.value) = $event))
                  }, props.value, { onClose: close }), null, 16, ["model2"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (content_filled.value)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), _mergeProps({
            key: 1,
            model2: model2.value.value,
            "onUpdate:model2": _cache[1] || (_cache[1] = ($event: any) => ((model2.value.value) = $event))
          }, props.value, { onClose: close }), null, 16, ["model2"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "fullscreen", "max-width", "persistent"]))
}
}

})